import * as types from "./reservationsActionsTypes";

export const reservationSearchRequest = (data) => {
  return { type: types.ADMIN_RESERVATIONS_SEARCH_REQUEST, data };
};

export const reservationModifyRequest = (data) => {
  return { type: types.ADMIN_RESERVATIONS_MODIFY_REQUEST, data };
};